











import { Component, Vue } from "vue-property-decorator";
// export default class Home extends Vue {}
export default {
  data() {
    return {
      imageArr: [
        "//enbrands-2.oss-cn-shanghai.aliyuncs.com/user/4be699842efc6bed5a57e9667ff43b88.jpg",
        "//enbrands-2.oss-cn-shanghai.aliyuncs.com/user/80bc79f07a60ca0edf7ad96270ed1241.jpg",
        "//enbrands-2.oss-cn-shanghai.aliyuncs.com/user/d2f54fd88e5930c97f7029e69f6712ea.jpg",
      ],
    };
  },
};
